export const API_CONFIG = {
  baseUrl: process.env.REACT_APP_API_BASE_URL || 'https://localhost:7018',
  debug: process.env.REACT_APP_DEBUG === 'true',
};
